import React from 'react';
import './WhyChooseStratX.css';

const comparisonData = [
  { feature: 'Launch Time', stratx: '2–4 Weeks', agentDealer: '1–3 Months', employee: '4–6 Months', showIcons: true },
  { feature: 'Financial Model', stratx: 'OpEx — Payment for Results', agentDealer: 'Commission-based; short-term focus', employee: 'CapEx — Salary + taxes + bonuses', showIcons: false },
  { feature: 'Loyalty & Control', stratx: '100% Dedicated', agentDealer: '5–10 brands in portfolio', employee: '100%', showIcons: true },
  { feature: 'Risk Level', stratx: 'Low', agentDealer: 'High', employee: 'Maximum', showIcons: true },
  { feature: 'Flexibility', stratx: 'High', agentDealer: 'Low', employee: 'Low', showIcons: true },
  { feature: 'Expertise', stratx: 'Full Team of Experts', agentDealer: "One person's experience", employee: "One person's skills", showIcons: true },
];

const WhyChooseStratX = () => (
  <section id="why" className="sec">
    <div className="w">
      <div className="rv">
        <div className="eye">Why StratX</div>
        <h2 className="sh">The <span>Clear</span> Advantage</h2>
        <p className="sl">How StratX compares to traditional alternatives like agents, dealers, or in-house employees.</p>
      </div>
      <div className="cw cw-desktop rv d1">
        <table className="ct">
          <thead>
            <tr>
              <th>Feature</th>
              <th className="ths">StratX</th>
              <th>Agent / Dealer</th>
              <th>In-house Employee</th>
            </tr>
          </thead>
          <tbody>
            {comparisonData.map((row) => (
              <tr key={row.feature}>
                <td className="tdf">{row.feature}</td>
                <td className="tds"><span className="ck">✓</span>{row.stratx}</td>
                <td>
                  {row.showIcons && <span className="cx">✗</span>}
                  {row.agentDealer}
                </td>
                <td>
                  {row.feature === 'Loyalty & Control' ? (
                    <><span className="ck">✓</span>{row.employee}</>
                  ) : (
                    <>{row.showIcons && <span className="cx">✗</span>}{row.employee}</>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="cw-mobile rv d1">
        {comparisonData.map((row) => (
          <div className="cmc" key={row.feature}>
            <div className="cmc-title">{row.feature}</div>
            <div className="cmc-row cmc-highlight">
              <span className="cmc-label">StratX</span>
              <span className="cmc-val"><span className="ck">✓</span>{row.stratx}</span>
            </div>
            <div className="cmc-row">
              <span className="cmc-label">Agent / Dealer</span>
              <span className="cmc-val">
                {row.showIcons && <span className="cx">✗</span>}
                {row.agentDealer}
              </span>
            </div>
            <div className="cmc-row">
              <span className="cmc-label">In-house Employee</span>
              <span className="cmc-val">
                {row.feature === 'Loyalty & Control' ? (
                  <><span className="ck">✓</span>{row.employee}</>
                ) : (
                  <>{row.showIcons && <span className="cx">✗</span>}{row.employee}</>
                )}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseStratX;
